/**
 * Селекторы, параметризованные по идентификатору магазина (shop).
 * Пример использования: useSelector(getOrder('eshop'))
 *
 * Исключение: getCheckoutVisible — глобальный селектор без параметра shop.
 * Пример использования: useSelector(getCheckoutVisible)
 */

export const getActiveShop = () => (state) => state.order.activeShop;

export const getOrder = (shop) => (state) => state.order.shops[shop]?.entities ?? {};
export const getOrderIsLoading = (shop) => (state) => state.order.shops[shop]?.isLoading ?? false;
export const getOrderNumber = (shop) => (state) => state.order.shops[shop]?.entities?.orderNumber;
export const getPayUrl = (shop) => (state) => state.order.shops[shop]?.payUrl ?? null;
export const getOrderNumberUuid = (shop) => (state) => state.order.shops[shop]?.entities?.orderNumberUuid;
export const getBillCreated = (shop) => (state) => state.order.shops[shop]?.billCreated ?? false;
export const getRegions = (shop) => (state) => state.order.shops[shop]?.regionList ?? [];
export const getRegionListLoaded = (shop) => (state) => state.order.shops[shop]?.regionListLoaded ?? false;
export const getCurrentRegion = (shop) => (state) => state.order.shops[shop]?.currentRegion ?? null;
export const getOrderRegion = (shop) => (state) => state.order.shops[shop]?.entities?.cardRegionCd;
export const getOrderError = (shop) => (state) => state.order.shops[shop]?.error ?? null;
export const getLastOrderError = (shop) => (state) => state.order.shops[shop]?.lastError ?? null;
export const getOrderStatus = (shop) => (state) => state.order.shops[shop]?.orderStatus ?? null;

/**
 * Глобальный селектор видимости формы оформления заказа.
 * Не зависит от конкретного магазина — применяется ко всем магазинам одновременно.
 */
export const getCheckoutVisible = (state) => state.order.checkoutVisible ?? false;
